






















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Project from "@/models/project/project";
import Request from "@/models/checkRequest/request";

@Component
export default class AddUrls extends Vue {
  @Prop() project!: Project;

  urlSource = "import";
  requests: Array<Request> = [];

  handleReady(result: Array<Request>) {
    if (result.length) {
      this.requests = result;
    }

    this.$emit("ready", this.requests);
  }
}
